import { createTRPCClient, createWSClient, wsLink } from '@trpc/client';
import type { AppRouter } from '../../console-server/src/main';
import type { UserRole } from 'shared/modelTypes';

let wsClient: ReturnType<typeof createWSClient>;

export let rpc: ReturnType<typeof createTRPCClient<AppRouter>>;

export let role: UserRole = 'game-master';

export async function setRole(r: UserRole) {
	role = r;
}

export async function createRpc() {
	wsClient = createWSClient({
		url: () => {
			return `${import.meta.env.VITE_WEBSOCKET_URL}?token=${getToken()}`;
		},
	});

	rpc = createTRPCClient<AppRouter>({
		links: [wsLink<AppRouter>({ client: wsClient })],
	});
	setRole(await rpc.getRole.query());
}

export function setToken(token: string | undefined) {
	const prev = localStorage.getItem('jwt') ?? '';
	if (prev != (token ?? '')) {
		localStorage.setItem('jwt', token ?? '');
		wsClient.reconnect();
	}
}

export function getToken(): string | undefined {
	const token = localStorage.getItem('jwt');
	if (!token) return undefined;
	return token;
}
